// extracted by mini-css-extract-plugin
export default {"content":"WhatIsTheIssue_content__SGnia","skeletonLoadingAnimation":"WhatIsTheIssue_skeletonLoadingAnimation__jN-8u"};